import React from 'react'

export const Inicio = () => {
  return (
    <div className="cont">
      <h1>Libreria de recursos</h1>

      <h2>Elementos de front-end realizados con React & Sass</h2>
      <p>No se trata de una librería comercial al uso, es más una cocina donde experimento y un almacen de recursos que suelo
        reutilizar constantemente... Al ser de uso personal, no he sentido la necesidad de optimizar esta página, para los distintos
        dispositivos. Disculpen las molestias... quizás en un futuro.<br />
        Para realizar, cada uno de los elementos se ha utilizado únicamente react, y scss</p>

      <p><i>By Titín Colomer</i></p>
    </div>
  )
}
